import ActivitiesConnected from './ActivitiesConnected'
export default ActivitiesConnected
